import Repository from './Repository';

export default class SerialNumberRepository extends Repository {
    protected basePath = 'devices/sn';

    protected messages = {
        destroy : this.__('Serial number successfully deleted.'),
        import : this.__('Serial numbers successfully imported.'),
        store : this.__('Serial number successfully created.'),
        update : this.__('Serial number successfully updated.'),
    }

    protected redirects = {
        import: { name : 'devices.pn.edit', params: { pn: '$part_number_id' } },
        store: { name : 'devices.sn.edit', params: { sn: '$id' } },
    }

    public export(params: object = null): Promise {
        console.error('Export method does not exist on SerialNumberRepository.');
    }
}